import { render } from "./EmployeeDashboard.vue?vue&type=template&id=dbd79d32&scoped=true"
import script from "./EmployeeDashboard.vue?vue&type=script&lang=js"
export * from "./EmployeeDashboard.vue?vue&type=script&lang=js"

import "./EmployeeDashboard.vue?vue&type=style&index=0&id=dbd79d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbd79d32"]])

export default __exports__